






















































































































































import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { CustomPaymentOptions, User } from "@fgl/funfangle-sdk/dist/rest/profile";
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { BankModule, NavModule, ProfileModule } from "@/store";
import {
  mdbAlert,
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbRow,
  mdbSelect
} from "mdbvue";
import { RouterUtils } from "@/router/RouterUtils";

@Component({
  components: {
    mdbAlert,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbInput,
    mdbRow,
    mdbSelect
  }
})
export default class BankTransfers extends mixins(RouterUtils) {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MQ = MQ;

  errorMessage: string | null = null;
  successMessage: string | null = null;
  fromAccountOptions: any[] = [];
  fromAccountText: string | null = null;
  fromAccountValue: string | null = null;
  toAccountOptions: any[] = [];
  toAccountText: string | null = null;
  toAccountValue: string | null = null;
  amount: string = "";
  isTransferProcessing: boolean = false;
  showConfirmation: boolean = false;

  // determine if button should be disabled
  get isTransferButtonDisabled() {
    // selected accounts cannot be the same
    // a dollar amount greater than zero but less than from account must be entered
    if (
      this.fromAccountValue == null ||
      this.toAccountValue == null ||
      this.fromAccountValue === this.toAccountValue ||
      this.amount == null ||
      this.amount === undefined ||
      Number(this.amount) <= 0 ||
      this.getAvailableBalance(this.fromAccountValue) < Number(this.amount)
    ) {
      // returns true if button is disabled
      return true;
    } else if (this.showConfirmation && this.isTransferProcessing) {
      // return true if there is a transfer in process
      return true;
    }
    return false;
  }
  get authorizedPersons(): User[] {
    return this.profileStore.authorizedActiveUsers;
  }
  get userContributionsByCamper(): Record<string, number> {
    return this.bankStore.userContributionByCamper;
  }

  @Watch("authorizedPersons")
  onAuthorizedPersonsChange() {
    this.toAccountOptions = this.buildOptions("to");
    this.fromAccountOptions = this.buildOptions("from");
  }
  @Watch("userContributionsByCamper")
  onUserContributionsByCamperChange() {
    this.toAccountOptions = this.buildOptions("to");
    this.fromAccountOptions = this.buildOptions("from");
  }
  // detect if the $route.hash has changed
  @Watch("$route", { immediate: true, deep: true })
  onRouteHashChange(newRoute: any, oldRoute: any) {
    if (oldRoute === undefined || oldRoute.hash !== newRoute.hash) {
      // console.log('location change', oldVal, newVal, this.$route.hash)
      if (this.$route.hash === "" || this.$route.hash === "#new-budget") {
        this.goNewStep();
      }
    }
  }
  // methods: {
  //   ...mapActions("bank", [
  //     "fetchAuthorizedUsers",
  //     "fetchUserTransactions",
  //     "transferFunds"
  //   ]),
  //   ...mapGetters("bank", [
  //     "getAuthorizedActivePersons",
  //     "getContributingToActive",
  //     "allowBankTransfers"
  //   ]),
  //   ...mapGetters("user", [
  //     "getUserContributionByCamper",
  //     "getOrgId",
  //     "getEmail",
  //     "getUserId"
  //   ]),
  //   ...mapActions("user", ["fetchAuthorizedPersons"]),
  // create from options dropdown items
  buildOptions(account: any) {
    // first element
    let firstOption = {
      text: this.$tc("phrase.select_account"),
      value: null,
      disabled: true,
      selected: true
    };
    // account options
    let accountOptions = [];
    let persons = this.profileStore.authorizedActiveUsers.concat(
      this.bankStore.contributingToActive
    );
    for (let index in persons) {
      let person = persons[index];
      accountOptions.push({
        text:
          person.firstName +
          " " +
          person.lastName +
          " (" +
          this.$n(
            this.userContributionsByCamper[person.userId || 'UNSET'] || 0,
            "currency"
          ) +
          ")",
        value: person.userId
      });
    }
    // payment options
    let paymentOptions: CustomPaymentOptions[] = [];
    // TODO: populate payment options
    /*
      let multiCamperDepositOption = {
        text: 'Multi-Camper Deposit',
        value: 'multi-camper-deposit'
      }
      */
    // initialize options
    let options = [];
    // build from options
    if (account === "from") {
      // add first line
      options.push(firstOption);
      // add payment methods
      for (let index in paymentOptions) {
        options.push(paymentOptions[index]);
      }
      // add accounts
      for (let index in accountOptions) {
        options.push(accountOptions[index]);
      }
    }
    // build to options
    if (account === "to") {
      // add first line
      options.push(firstOption);
      // add accounts
      for (let index in accountOptions) {
        // if selected as from account, then do not include
        if (accountOptions[index].value !== this.fromAccountValue) {
          options.push(accountOptions[index]);
        }
      }
      // add payment methods
      for (let index in paymentOptions) {
        options.push(paymentOptions[index]);
      }
    }

    // return
    return options;
  }
  getAvailableBalance(userId: string | null): number {
    if (userId == null) return 0;
    let person = this.getPerson(userId);
    if (person != null && person !== undefined && person.userId !== undefined) {
      return this.userContributionsByCamper[person.userId] || 0;
    }
    return 0;
  }
  getPerson(userId: string): User | undefined {
    return this.profileStore.authorizedActiveUsers.find(function(person) {
      if (person.userId === userId) {
        return person;
      }
    });
  }
  // show the confirmation section for user affirmation
  goNewStep(): void {
    this.fromAccountText = "";
    this.fromAccountValue = null;
    this.toAccountText = "";
    this.toAccountValue = null;
    this.amount = "";
    this.errorMessage = null;
    this.successMessage = null;
    this.showConfirmation = false;
    // add hash to URL
    window.location.hash = "new";
  }
  // show the confirmation section for user affirmation
  goEditStep(): void {
    this.successMessage = null;
    this.showConfirmation = false;
    // add hash to URL
    window.location.hash = "edit";
  }
  // show the confirmation section for user affirmation
  goConfirmationStep(): void {
    this.successMessage = null;
    this.showConfirmation = true;
    // add hash to URL
    window.location.hash = "confirm";
  }
  // perform the function to process the confirmed transfer
  handleTransfer(): void {
    // set flag as processing
    this.isTransferProcessing = true;
    // create payload
    let payload = {
      fromAccount: this.fromAccountValue,
      toAccount: this.toAccountValue,
      amount: parseFloat(this.amount),
      organizationId: this.profileStore.organizationId,
      contributorEmail: this.profileStore.email,
      contributorId: this.profileStore.userId,
      userId: this.profileStore.userId
    };
    // perform action
    this.bankStore.transferFunds(payload)
      .then(async () => {
        // set success message and change window location
        this.successMessage = this.$tc("phrase.successfully_transferred_funds");
        window.location.hash = "success";
        // reset variables
        this.isTransferProcessing = false;
        this.showConfirmation = false;
        const calls: Promise<any>[] = [];
        // re-fetch the data
        calls.push(this.profileStore.fetchUserPairs());
        calls.push(this.profileStore.fetchAuthorizedPersons({
          authorizedUsers: this.profileStore.authorizedActiveUsers,
          contributingTo: this.bankStore.contributingToActive
        }))
        // refresh transactions
        calls.push(this.bankStore.fetchUserTransactions({ userId: this.profileStore.userId }));
        await Promise.all(calls);
      })
      .catch((err: Error) => {
        // handle error
        // TODO-MATT: Handle this better
        // TODO Log this
        // console.log("Error:", err);
        this.errorMessage = "Error occurred: " + err;
        window.location.hash = "error";
        // reset variables
        this.isTransferProcessing = false;
        this.showConfirmation = false;
      });
  }
  // set the "from" value from the drop down
  setFromAccount(userId: string, text: string): void {
    this.fromAccountText = text;
    this.fromAccountValue = userId;
    // rebuild to options
    this.toAccountOptions = this.buildOptions("to");
  }
  // set the "to" value from the drop down
  setToAccount(userId: string, text: string): void {
    this.toAccountText = text;
    this.toAccountValue = userId;
  }

  created(): void {
    this.toAccountOptions = this.buildOptions("to");
    this.fromAccountOptions = this.buildOptions("from");
  }
  mounted(): void {
    if (!this.navStore.allowBankTransfers) {
      // console.log("Transfers not allowed. Redirecting...");
      this.goBankPage();
    }
  }
}
